var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "about-us-our-values"
  }, [_c('PageTitle', {
    attrs: {
      "title": _vm.$t('components.main.navigation.about.us.our-values'),
      "bordered": true
    }
  }), _vm._v(" "), _c('Hero', {
    attrs: {
      "height": "auto",
      "image": {
        height: 400,
        classes: 'tw-object-contain tw-max-w-full tw-h-auto min-[1110px]:tw-h-[400px]'
      },
      "url": "/assets/images/our-values/hero_nobg.png",
      "background": "linear-gradient(to bottom, #fdd4aa, #fff6d2) no-repeat center"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tw-grid tw-grid-cols-12 tw-container tw-px-0"
  }, [_c('div', {
    staticClass: "value-selector tw-flex-row tw-justify-between tw-border-solid tw-border-0 tw-border-b tw-text-zinc-450 tw-border-b-zinc-450 tw-mt-16 tw-px-6 lg:tw-px-0 tw-col-span-12 tw-gap-2 lg:tw-col-span-6 lg:tw-col-start-4 tw-hidden lg:tw-flex"
  }, _vm._l(_vm.values, function (value) {
    return _c('div', {
      staticClass: "value-name tw-font-semibold tw-text-4 tw-pb-4 tw-text-center cursor-pointer",
      class: {
        'tw-text-primary tw-border-solid tw-border-0 tw-border-b-2 tw-border-b-primary': _vm.selectedValue === value.key
      },
      on: {
        "click": function ($event) {
          _vm.selectedValue = value.key;
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t(`components.our-values.${value.key}`)) + "\n      ")]);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "general-input lg:tw-hidden tw-col-span-12 tw-mt-8 tw-px-6"
  }, [_c('div', {
    staticClass: "field field-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedValue,
      expression: "selectedValue"
    }],
    staticClass: "input tw-border-none tw-appearance-none",
    attrs: {
      "id": "value_id",
      "type": "text",
      "name": "value_id",
      "data-vv-as": _vm.$t('components.main.navigation.about.us.our-values')
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.values, function (value) {
    return _c('option', {
      attrs: {
        "label": _vm.$t(`components.our-values.${value.key}`)
      },
      domProps: {
        "value": value.key
      }
    });
  }), 0), _vm._v(" "), _c('label', {
    attrs: {
      "for": "value_id",
      "data-tid": "subject_label"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('components.main.navigation.about.us.our-values')) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "values xs:tw-grid tw-grid-cols-12 tw-gap-10 tw-mt-10 lg:tw-mt-14 lg:tw-px-0 tw-container tw-px-0"
  }, _vm._l(_vm.selectedKeyValues, function (valueItem) {
    return _c('div', {
      staticClass: "tw-grid tw-grid-cols-12 tw-col-span-12 tw-px-6 lg:tw-px-0 tw-mb-7.5 xs:tw-mb-0"
    }, [_c('div', {
      staticClass: "tw-order-1 tw-col-span-12 lg:tw-col-span-2 tw-hidden lg:tw-block",
      class: {
        'lg:tw-col-start-2 lg:tw-mr-[30px] lg:tw-ml-[-30px]': !valueItem.reverse,
        'lg:tw-col-start-10 lg:tw-order-2 lg:tw-mr-[-30px] lg:tw-ml-[30px]': valueItem.reverse
      }
    }, [_c('nuxt-img', {
      staticClass: "lg:tw-max-w-full lg:tw-h-auto lg:tw-w-full tw-text-center",
      attrs: {
        "src": valueItem.img,
        "alt": valueItem.title,
        "width": "180",
        "height": "180",
        "loading": "lazy"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "tw-col-span-12 lg:tw-col-span-6 lg:tw-col-start-4 tw-order-2",
      class: {
        'lg:tw-order-1': valueItem.reverse,
        'lg:tw-order-2': !valueItem.reverse
      }
    }, [_c('h2', {
      staticClass: "tw-text-7 tw-font-semibold tw-leading-8 tw-hidden lg:tw-block"
    }, [_vm._v(_vm._s(valueItem.title))]), _vm._v(" "), _c('h4', {
      staticClass: "tw-text-5 tw-font-semibold tw-leading-6 tw-block lg:tw-hidden"
    }, [_vm._v(_vm._s(valueItem.title))]), _vm._v(" "), _c('p', {
      staticClass: "tw-text-zinc-450 tw-text-14 tw-leading-5"
    }, [_vm._v(_vm._s(valueItem.content))])])]);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "px-20 px-md-30 py-30 py-lg-40"
  }, [_c('div', {
    staticClass: "new-container mx-auto"
  }, [_c('div', [_c('BottomBanner', {
    attrs: {
      "image-url": "/assets/images/airalo-careers/job-vacancies-banner.jpg"
    }
  }, [_c('div', {
    staticClass: "display-flex flex-column justify-content-center align-items-center w-100"
  }, [_c('h2', {
    staticClass: "typo-h1 mb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('components.banner.job.vacancies.title')) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "typo-p mb-0 mt-10 text-center"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('components.banner.job.vacancies.subtitle')) + "\n            ")]), _vm._v(" "), _c('nuxt-link', {
    staticClass: "button button-secondary btn-primary-hv shadowed minw-224 mt-20 text-center",
    attrs: {
      "to": _vm.localePath({
        name: 'airalo-careers-working-at-airalo'
      })
    },
    nativeOn: {
      "click": function ($event) {
        _vm.sendEventHandler({
          text: _vm.$t('components.banner.job.vacancies.button-title'),
          url: _vm.localePath({
            name: 'airalo-careers-working-at-airalo'
          })
        });
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('components.banner.job.vacancies.button-title')) + "\n            ")])], 1)])], 1)])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }